import BaseModel from '../model/BaseModel';
import Collection from './Collection';
import VistaDate from './VistaDate';
import Ticket from './Ticket';
import ModelArray from './ModelArray';
import MovieService from '../service/movie-service'
import OrderService from '../service/order-service'

export default class Session extends BaseModel {

    constructor(data) {
        super();
        this.SessionId = data.SessionId;
        this.CinemaId = data.CinemaId;
        this.FilmTitle = data.FilmTitle;
        this.ShowingRealDateTime = data.ShowingRealDateTime ? new VistaDate(data.ShowingRealDateTime) : data.ShowingRealDateTime;
        this.Tickets = data.Tickets ? new ModelArray(data.Tickets, Ticket) : [];
        this.TicketTypes = data.TicketTypes;
        this.UnassignedTickets = data.UnassignedTickets;
        this.movie = undefined;
        this.SeatGrid = [];
        this.MoviePromise = MovieService.findBySessionId(this.SessionId,this.CinemaId).then((movie)=>{
            this.movie = movie
        })
        this.SeatGridPromise = undefined;
        this.Loyalties = data.Loyalties || [];
        this._loadingGrid = false;

        if (this.Loyalties) {
            try {
                var loyalties = JSON.parse(localStorage.getItem("loyalties")) || [];
                for (var i = 0; i < this.Loyalties.length; i++) {
                    var loyalty = this.Loyalties[i];
                    var localLoyalty = loyalties.find((l)=> {
                        return l.SessionId == this.SessionId && l.TicketTypeCode == loyalty.TicketType.TicketTypeCode && !l.processed;
                    });
                    if (localLoyalty) {
                        Object.assign(loyalty, localLoyalty);
                        localLoyalty.processed = true;
                    }

                }
            } catch (e) {
                console.warn(e);
            }
            this.Loyalties = data.Loyalties;
        }

    }

    get loadingGrid() {
        return this._loadingGrid
    }

    get positions() {
        return this.Tickets ? this.Tickets.reduce((c, t)=> {
            c[t.Position.RowIndex] = c[t.Position.RowIndex] || [];
            let seatId = !isNaN(t.SeatId) ? t.SeatId : Number(t.SeatNumber);
            c[t.Position.RowIndex].push(seatId);
            c[t.Position.RowIndex] = c[t.Position.RowIndex].sort();
            return c;
        }, {}): {};
    }

    get MovieSession() {
        return this.movie ? this.movie.cinemas[this.CinemaId].find((session)=>session.id == this.SessionId) : {};
    }

    get SessionDate() {
        return this.ShowingRealDateTime;
    }

    get SessionEndDate() {
        if (this.SessionDate && this.movie) {
            return new VistaDate(this.SessionDate.date.clone().add(this.movie.runtime, 'minutes'));
        }

    }

    get SeatString() {

        var string = this.Tickets.reduce((arr, ticket)=> {
            arr[ticket.SeatRowId] = arr[ticket.SeatRowId] || {min: 10, max: 0};
            arr[ticket.SeatRowId].min = arr[ticket.SeatRowId].min > ticket.SeatNumber ? ticket.SeatNumber : arr[ticket.SeatRowId].min;
            arr[ticket.SeatRowId].max = arr[ticket.SeatRowId].max < ticket.SeatNumber ? ticket.SeatNumber : arr[ticket.SeatRowId].max;
            arr[ticket.SeatRowId].key = ticket.SeatRowId;
            return arr;
        }, {})
        string = Object.keys(string).map(function (key) {
            var ticket = string[key];
            if (ticket.min == ticket.max) {
                return `${ticket.key}${ticket.min}`
            }
            return `${ticket.key}${ticket.min} - ${ticket.key}${ticket.max}`
        }).join(',');


        return string;
    }

    getSeatGrid() {
        this._loadingGrid = true;

        this.SeatGridPromise = this.SeatGridPromise || OrderService.getSeatGrid(this.SessionId, this.CinemaId, this.Tickets)

        return this.SeatGridPromise.then((seatGrid)=> {
            this._loadingGrid = false;
            seatGrid.mapTicketsToGrid(this.Tickets);
            return this.SeatGrid = seatGrid
        }, (e)=> {
            this._loadingGrid = false;
            this.SeatGridPromise = undefined;
            this.SeatGrid = [];
            return Promise.reject(e);
        });
    }


}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/Session.js